import axios from 'axios';
import { setSomethingWentWrong, store } from '../../redux';
import Utils from '../../components/utils';
import Config, { Process as process } from '../../config/appConstants';
import StackTrace from 'stacktrace-js'
// import Config from '../../config/appConstants';

function getHostName(url) {
  var match = "";
  if(url.includes(":")) {
    match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+:(\d*))/i);
    // let cmsHost = ['34.225.130.79:11095', 'devportal.housing.gov.om:10443', 'stgportal-1.housing.gov.om:10443'];
    let cmsHost = process.env.REACT_APP_ENV_URL;
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
      if (cmsHost.includes(match[2])) {
        return { type: "CMS", url: 'lcms', encMode: 1 };
      } else {
        return { type: "BW", url: 'lapps', encMode: 1 };
      }
    } 
  } else if(url.includes("/")){
    match = url.split('/');
    if(match[1] === "cmsapi") {
      return { type: "CMS", url: 'lcms', encMode: 1 };
    } else {
      return { type: "BW", url: 'lapps', encMode: 1 };
    }
  } else {
    return null;
  }
}

function logNode() {
  axios.interceptors.request.use(request => {
    if(Config.ENABLE_UI_LOGS) {
      loggerPayload({ request: request });
    }
    return request
  })

  axios.interceptors.response.use(response => {
    if(Config.ENABLE_UI_LOGS) {
      loggerPayload({ response: response });
    }
    return response
  }, err => {
    if(Config.ENABLE_UI_LOGS) {
      loggerPayload({ response: err.response });
    }
    if(typeof(err.response.data) === 'string'){
      const decrypted = JSON.parse(Utils.bwDecryptHeaderAuthKey(atob(err.response.data)))
      return Promise.reject(decrypted);
    }
  })
}

function templateCallCheck(postData) {
  if (postData.hasOwnProperty('response')) {
    if (postData.response.config.method.toUpperCase() === 'GET') { // GET 
      const fileExtension = postData.response.config.url.split(/\.(?=[^\\.]+$)/);
      if (fileExtension[1] === "json") { // template
        return fileExtension[1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else if (postData.hasOwnProperty('request')) {
    if (postData.request.method.toUpperCase() === 'GET') { // GET 
      const fileExtension = postData.request.url.split(/\.(?=[^\\.]+$)/);
      if (fileExtension[1] === "json") { // template
        return fileExtension[1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}

async function loggerPayload(postData) {

  let logObj = {};
  let routeObj;
  let postObj = postData.hasOwnProperty('response') ? 'response' : 'request';

  if (postData.request !== undefined) {
    routeObj = getHostName(postData[postObj].url);
  } else if (postData.response !== undefined) {
    routeObj = getHostName(postData[postObj].config.url);
  } else {
    routeObj = null;
  }

  if (routeObj !== null && (postData.response !== undefined || postData.request !== undefined)) { // valid url match

    // if (urlExt !== "json") {

    if (postData.request !== undefined) {

      logObj = {
        request: {
          TransactionID: postData.request.headers.TransactionID,
          reqTime: Utils.getDateAsText(),
          url: postData.request.url,
          method: postData.request.method,
          reqHeader: JSON.stringify(postData.request.headers),
          reqPayLoad: postData.request.data
        }
      }
    } else {
      logObj = {
        response: {
          TransactionID: postData.response.config.headers.TransactionID,
          status: postData.response.request.status,
          respTime: Utils.getDateAsText(),
          url: postData.response.config.url,
          respHeader: postData.response.request.status >= 400 && postData.response.request.status <= 561 ? JSON.stringify(postData.response.headers) : JSON.stringify(postData.response.headers),
          respBody: postData.response.request.responseText,
        }
      }
    }

    // only for fileupload
    if (logObj.hasOwnProperty("request") && logObj.request.method === "post" && logObj.request.url === Config.FILE_UPLOAD) {
      // Display the key/value pairs
      let formDataObj = {};
      for (var pair of logObj.request.reqPayLoad.entries()) {
        formDataObj[pair[0]] = routeObj.encMode === 1 ? Utils.bwDecryptHeaderAuthKey(atob(pair[1])) : pair[1];
      }
      logObj.request.reqPayLoad = btoa(Utils.bwEncryptHeaderAuthKey(formDataObj));
    }
// console.log("logObj")
// console.log(logObj)

    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': '*/*',
        'Content-Type': "application/json"
      },
      body: JSON.stringify({ data: Utils.encryptRequestBody(logObj), md: routeObj.encMode }),
      mode: "cors"
    };
    let systemLog;
   

    if (templateCallCheck(postData) === null) {
      if (postData.hasOwnProperty(postObj)) {
        systemLog = routeObj !== null ? routeObj.url : 'lapps-remove';
        //const systemLog = isCms ? 'lcms' : 'lapps'
        let endPointURL = process.env.REACT_APP_API_LOG + systemLog;
        await fetch(endPointURL, requestOptions);
      }
    }
  }
}

const loginHeader = {
  'accept': 'application/json',
  'content-type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  //'RequestID': (new Date().valueOf()),
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'ApplicantType': 'USER',
  "TransactionID": ""
};

const FreezeUnFreezeHeader = {
  'accept': 'application/json',
  'content-type': 'application/json',
  //'RequestID': (new Date().valueOf()),
  'SessionID': '',
  'Region': 'MCT',
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'ApplicantType': 'CUST',
  "AdditionalParams": "",
  "TransactionID": ""
}

const afterLoginHeader = {
  'accept': 'application/json',
  'content-type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  //'RequestID': (new Date().valueOf()),
  'SessionID': '',
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'ApplicantType': 'USER',
  "TransactionID": ""
}

const afterLoginHeaderCreateUpdate = {
  'accept': 'application/json',
  'content-type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  //'RequestID': (new Date().valueOf()),
  'SessionID': '',
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'ApplicantType': 'USER',
  "TransactionID": ""
}

const fileUploadHeader = {
  'accept': 'application/json',
  'content-type': 'multipart/form-data',
  //'RequestID': (new Date().valueOf()),
  'SessionID': '',
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'ApplicantType': 'USER',
  "TransactionID": ""
}

const paymentHeader = {
  'accept': 'application/json',
  'content-type': 'application/json',
  //'RequestID': (new Date().valueOf()),
  'SessionID': '',
  'Region': 'MCT',
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'ApplicantType': 'USER',
  "TransactionID": ""
}

const afterLoginHeaderCommercial = {
  'accept': 'application/json',
  'content-type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  //'RequestID': (new Date().valueOf()),
  'SessionID': '',
  'ApplicationID': 'WEB',
  'ChannelID': 'WEB',
  'CountryCode': 'OM',
  'Name': 'OMAN',
  'ApplicantType': 'USER',
  "TransactionID": ""
}

// axios body
let LookupAPIResponse = {};

function axiosResponseBody(type, url, customHeader, postData, params, customAttributes) {

  let fileExt = "";

  let config, queryString;
  let NotEncryptedData;

  //let hostObj = getHostName(url);

  // let modeObj  = getHostName()

  if (type === 'GET') { // GET 

    let urlObj = url.split(/\.(?=[^\\.]+$)/);
    let urlExt = urlObj[1];
    if (urlExt !== "json") {
      if (params !== "" || Object.keys(params).length !== 0) {
        if (typeof params === "object") {
          queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&').replace(/\s/g, '%20');
        } else {
          queryString = params.replace(/\s/g, '%20');
        }
      }
    } else {
      queryString = "";
      fileExt = urlExt;
    }

    if (urlExt !== "json" && (queryString !== '' || Object.keys(queryString).length !== 0)) {
      let qString;
      // if (hostObj !== null && hostObj.encMode === 1) {
        let param = btoa(Utils.bwEncryptHeaderAuthKey(queryString));
        qString = "?param=" + param.replace(/"/g, "");
      // } else {
      //   qString = "?" + queryString;
      // }

      config = {
        method: type,
        url: url + qString,
        headers: customHeader,
      }
    } else {
      config = {
        method: type,
        url: url,
        headers: customHeader,
      }
    }

  } else { // POST, PUT
    let postQueryEncrypt = '', queryString = "", param = '';
    if (params !== "" || Object.keys(params).length !== 0 || params !== undefined) {

      if (typeof params === "object" && Object.keys(params).length !== 0) {
        if (Object.keys(params).length) {
          queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&').replace(/\s/g, '%20');
        }
      } else if (typeof params === "string" && params.length > 1) {
        queryString = params.replace(/\s/g, '%20');
        //queryString =  params;
      }
      if(url === Config.GET_UTILITY_LOOKUP){
        if(queryString !== ""){
           //postQueryEncrypt = "?" + queryString;
           postQueryEncrypt = "?param=" + btoa(Utils.bwEncryptHeaderAuthKey(queryString)).replace(/"/g, "");
        }
        NotEncryptedData = postData;
        param = btoa(Utils.bwEncryptHeaderAuthKey(postData));
        // param = postData;
        // console.log(param, postData);
      }else{ 
        param = btoa(Utils.bwEncryptHeaderAuthKey(queryString));
        if (queryString !== "") {
          postQueryEncrypt = "?param=" + param.replace(/"/g, "");
        }
        param = btoa(Utils.bwEncryptHeaderAuthKey(postData));
      }
    }
    
    if(customAttributes?.encryptData) {
      param= postData;
    } 
    config = {
      method: type,
      url: url === Config.GET_UTILITY_LOOKUP ?  url + postQueryEncrypt : postQueryEncrypt === '' ? url : url + postQueryEncrypt ,
      // url: postQueryEncrypt === '' ? url : url + postQueryEncrypt,
      data: url ===  Config.GET_UTILITY_LOOKUP ? param : param.replace(/"/g, ""),
      headers: customHeader
    }

  }
  let requiredString;
  if(url === Config.GET_UTILITY_LOOKUP  && Config.MODULE_CONFIG.DYNAMIC_CACHE) {
    let LookupFields = Utils.getLookupDataResponse(NotEncryptedData, LookupAPIResponse);
    requiredString = LookupFields.requiredString
    if (LookupFields.hasOwnProperty("isPresent") && LookupFields?.isPresent === true) {
      return Promise.resolve({ data: LookupFields.returnData })
    }
    if (LookupFields.hasOwnProperty("LookupResponse")) {
      LookupAPIResponse = { ...LookupFields.LookupResponse }
    }
  }

  return new Promise((resolve, reject) => {
    axios.request(config).then(response => {
      if (type === "GET" && fileExt === "json") {
        resolve({
          data: response.data
        });
      } else {
        let decrypted = ''
        decrypted = JSON.parse(Utils.bwDecryptHeaderAuthKey(atob(response.data)))
        if(url === Config.GET_UTILITY_LOOKUP){
          //decrypted = response.data
          if(Config.MODULE_CONFIG.DYNAMIC_CACHE) {
            let finalResponse = Utils.setLookupDataResponse(requiredString, decrypted, LookupAPIResponse)
            LookupAPIResponse = {...finalResponse};
            Utils.setStorageWithExpiry("LookupData", LookupAPIResponse, Number(Config.MODULE_CONFIG.DYNA_STORE_EXPIRY));
          }
        }
        // else{
        //   decrypted = JSON.parse(Utils.bwDecryptHeaderAuthKey(atob(response.data)))
        // }
        resolve({
          data: decrypted
        });

      }

    }).catch(err => {
      reject(err)
    })
  })

}


export const logErrorAPI= async (error, isPortal)=>{
  // console.log("111")
  const transactionID = Utils.getUniqueTranscationID()
  let errObj = {transactionID}
  StackTrace.fromError(error).then(err => {
    // console.log(err)
    err.map((er,index)=>(
        errObj[`err${index}`] = er
    ))

    store.dispatch(setSomethingWentWrong())
    // console.log("error logapa",error)
    // createRequest("POST",process.env.REACT_APP_API_LOG + "error-log",0,{error})
     //new Date().getFullYear().toString() + new Date().getHours().toString() + new Date().getMinutes().toString() + new Date().getSeconds().toString() + new Date().getDate().toString();;
    // const url = `${process.env.REACT_APP_API_LOG}${isPortal ? 'lcms' : 'lapps'}`; //process.env.REACT_APP_API_LOG + 
    // const errorObjWithTranID = {"TransactionID":transactionID,...errObj}

    // console.log("errorObjWithTranID",errObj)
  
    // fetch(url,{
    //   method:'POST',
    //   body:JSON.stringify({ data:Utils.encryptRequestBody(errObj), md: getHostName(url).encMode }),
    //   headers:{
    //     "content-type":"application/json",
    //     "TransactionID":transactionID
    //   }
    // }).then(res=>res.text())
    // .then(res=>{
    //   //console.log("logerrrr",res)
    // })
  })
 
}
// if(Config.ENABLE_UI_LOGS) {
  logNode();
// }


export function createRequest(type, url, headerType, postData = '', params = '', customAttributes) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID(); //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.Authorization = `Basic ${Utils.encryptHeaderAuthKey(loginData.SessionID)}`;
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeader.SessionID = loginData.SessionID;

      //afterLoginHeader.Authorization = `Basic ${Utils.encryptHeaderAuthKey(loginData.SessionID)}`;
    }
    afterLoginHeader.TransactionID =  Utils.getUniqueTranscationID() // (Date.now() + ((Math.random() * 1000).toFixed()));
    if(customAttributes?.header) {
      afterLoginHeader[customAttributes?.header.headerParam] = customAttributes?.header.headerValue;
    }
    else if(customAttributes?.AdditionalParams) {
      afterLoginHeader.AdditionalParams = customAttributes?.AdditionalParams;
    }
    customHeader = afterLoginHeader;
  }
  return axiosResponseBody(type, url, customHeader, postData, params, customAttributes);
}

export function createRequestFileUpload(type, url, headerType, postData, encMode = 0, customAttributes = {}) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      fileUploadHeader.SessionID = loginData.SessionID;
      // fileUploadHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      fileUploadHeader.SessionID = loginData.SessionID;
      //fileUploadHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }
    fileUploadHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    if (customAttributes?.header) {
      fileUploadHeader[customAttributes?.header.headerParam] = customAttributes?.header.headerValue;
    }
    customHeader = fileUploadHeader;
  }

  let config = {
    method: type,
    url: url,
    data: postData,
    headers: customHeader
  }
  return new Promise((resolve, reject) => {
    axios.request(config).then(response => {
      const decrypted = encMode === 1 ? JSON.parse(Utils.bwDecryptHeaderAuthKey(atob(response.data))) : response.data
      resolve({
        data: decrypted
      });

    }).catch(err => {
      console.log('err', type, err);
      reject(err)
    })
  })
}

export function createRequestPayment(type, url, headerType, postData = '', params = '') {

  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      paymentHeader.SessionID = loginData.SessionID;
      //paymentHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      paymentHeader.SessionID = loginData.SessionID;
      //paymentHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }
    paymentHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = paymentHeader;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}

export function paymentGatewayRESTCall(type, url, headerType, params, sessionID, postData = '') {

  var customHeader = '';
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    paymentHeader.SessionID = sessionID;
    paymentHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    //paymentHeader.AuthToken = Utils.encryptHeaderAuthKey(sessionID);
    customHeader = paymentHeader;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}

export function createRequestFreezeUnFreeze(type, url, headerType, postData = '', params = '', InvolvedPartyID) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      FreezeUnFreezeHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.Authorization = `Basic ${Utils.encryptHeaderAuthKey(loginData.SessionID)}`;
    } else {
      loginData = store.getState().pki_details;
      FreezeUnFreezeHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.Authorization = `Basic ${Utils.encryptHeaderAuthKey(loginData.SessionID)}`;
    }
    FreezeUnFreezeHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    FreezeUnFreezeHeader.AdditionalParams = 'concernedpartyid:' + InvolvedPartyID;
    customHeader = FreezeUnFreezeHeader;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}

export function mohUserCreateRequest(type, url, headerType, postData = '', params) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }
    afterLoginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = afterLoginHeader;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}

export function applicantCreateUpdateRequest(type, url, headerType, postData = '', params) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    var resourceDetails = store.getState().resourceDetails;
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeaderCreateUpdate.SessionID = loginData.SessionID;
      //afterLoginHeaderCreateUpdate.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeaderCreateUpdate.SessionID = loginData.SessionID;
      //afterLoginHeaderCreateUpdate.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }

    if (Object.keys(resourceDetails).length) {
      afterLoginHeaderCreateUpdate.ActionUserName = resourceDetails.InvolvedPartyID;
      // let InvolvedPartyName =  (store.getState()?.lang?.lang && store.getState()?.lang?.lang === Config.LANG.AR) ? resourceDetails?.InvolvedPartyNameArabic : resourceDetails?.InvolvedPartyName; 
      // afterLoginHeaderCreateUpdate.ActionUserName = resourceDetails?.InvolvedPartyName;
      afterLoginHeaderCreateUpdate.ActionUserGUID = resourceDetails.guid;
      afterLoginHeaderCreateUpdate.ActionUserPosition = resourceDetails.Positions[0].name;
      afterLoginHeaderCreateUpdate.ActionUserDepartment = resourceDetails.Positions[0].hierarchy;
    }
    afterLoginHeaderCreateUpdate.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = afterLoginHeaderCreateUpdate;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}


export function createUpdateEncryptRequest(type, url, headerType, postData = '', params) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    var resourceDetails = store.getState().resourceDetails;
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeaderCreateUpdate.SessionID = loginData.SessionID;
      //afterLoginHeaderCreateUpdate.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeaderCreateUpdate.SessionID = loginData.SessionID;
      //afterLoginHeaderCreateUpdate.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }

    if (Object.keys(resourceDetails).length) {
      afterLoginHeaderCreateUpdate.ActionUserName = resourceDetails.InvolvedPartyID;
      // let InvolvedPartyName =  (store.getState()?.lang?.lang && store.getState()?.lang?.lang === Config.LANG.AR) ? resourceDetails?.InvolvedPartyNameArabic : resourceDetails?.InvolvedPartyName; 
      // afterLoginHeaderCreateUpdate.ActionUserName = resourceDetails?.InvolvedPartyName;
      afterLoginHeaderCreateUpdate.ActionUserGUID = resourceDetails.guid;
      afterLoginHeaderCreateUpdate.ActionUserPosition = resourceDetails.Positions[0].name;
      afterLoginHeaderCreateUpdate.ActionUserDepartment = resourceDetails.Positions[0].hierarchy;
    }
    afterLoginHeaderCreateUpdate.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = afterLoginHeaderCreateUpdate;
  }
  return axiosResponseBody(type, url, customHeader, postData, params, { encryptData : true});
}

export function applicantCreateRequest(type, url, headerType, postData = '', params) {

  var customHeader = '';
  // let config;
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = (Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }
    afterLoginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = afterLoginHeader;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}

export function createConcurrentRequest(type, url, headerType = `1`, postData = '', params) {

  var defaultHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    defaultHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeader.SessionID = loginData.SessionID;
      //afterLoginHeader.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }
    afterLoginHeader.TransactionID = Utils.getUniqueTranscationID()// (Date.now() + ((Math.random() * 1000).toFixed()));
    defaultHeader = afterLoginHeader;
  }
  return axiosResponseBody(type, url, defaultHeader, postData, params);
}

export function applicantCommercialRequest(type, url, headerType, postData = '', params) {
  var customHeader = '';
  let loginData;
  if (headerType === 0) {
    loginHeader.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = loginHeader;
  } else {
    if (store.getState().pki_details.hasOwnProperty("OrgUserValidator")) {
      loginData = store.getState().pki_details.OrgUserValidator;
      afterLoginHeaderCommercial.SessionID = loginData.SessionID;
      //afterLoginHeaderCommercial.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    } else {
      loginData = store.getState().pki_details;
      afterLoginHeaderCommercial.SessionID = loginData.SessionID;
      //afterLoginHeaderCommercial.AuthToken = Utils.encryptHeaderAuthKey(loginData.SessionID);
    }
    afterLoginHeaderCommercial.TransactionID = Utils.getUniqueTranscationID() //(Date.now() + ((Math.random() * 1000).toFixed()));
    customHeader = afterLoginHeaderCommercial;
  }
  return axiosResponseBody(type, url, customHeader, postData, params);
}

export async function isMortgageCompoundService(data) {
  let mortgageCompoundService = data.hasOwnProperty("RERequestApplications") && data.RERequestApplications.hasOwnProperty("IsCompoundService") && !["", "S", null, undefined].includes(data.RERequestApplications.IsCompoundService) && data.RERequestApplications.IsCompoundService ? "M" : false;
  return mortgageCompoundService;
}

export async function isShowMortgageDetailsOnTemplate(data) {
  let checkMortgageDetails = data.hasOwnProperty("ApplicationData") && data.ApplicationData.hasOwnProperty("ReferenceApplicationID") && data.ApplicationData.ReferenceApplicationID !== "" ? data.ApplicationData.ReferenceApplicationID : false;
  if (checkMortgageDetails !== false && checkMortgageDetails !== "") {
    checkMortgageDetails = true;
  } else {
    checkMortgageDetails = false;
  }
  return checkMortgageDetails;
}